import type { FormDataType } from '../../contexts/FormProvider';
import type { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnySetValue = UseFormSetValue<any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyGetValues = UseFormGetValues<any>;
export type AddressUpdateMap = Record<string, unknown>;

export enum AddressType {
  Postal = 'postal',
  RepPostal = 'repPostal',
  Physical = 'physical',
}
export interface AddressFieldMap {
  /** Value used as the AddressSearch `fieldName` prop */
  fieldName: string;
  /** Top-level address string (lookup display value) */
  address: keyof FormDataType;
  /** Raw AddressList item stored for re-hydration */
  addressObject: keyof FormDataType;
  streetAddress: keyof FormDataType;
  suburb: keyof FormDataType;
  state: keyof FormDataType;
  postcode: keyof FormDataType;
  country: keyof FormDataType;
  isManualAddress: keyof FormDataType;
  /** Flag set to true when a valid lookup address is selected */
  isAddressValid: keyof FormDataType;
  /** Optional flag used by some forms to track manual-address validity */
  isManualAddressValid?: keyof FormDataType;
}
